module.exports = __webpack_public_path__ + "img/figure-9.cbe3193f.png";